import FootprintFormFlight from "../../components/FootprintForm/FootprintFormFlight"
import Footer from '../../components/Footer/Footer'
import './FootprintPages.css'

const FootprintPageFlight = () => {

    return (
        <>
            <FootprintFormFlight />
            <Footer />

        </>
    )
}

export default FootprintPageFlight